module.exports = __webpack_public_path__ + "static/shot1-04e28b058aa683f97a7a21970a7e0973.png";